import { render, staticRenderFns } from "./expenseAccount.vue?vue&type=template&id=5936055f&scoped=true&"
import script from "./expenseAccount.vue?vue&type=script&lang=js&"
export * from "./expenseAccount.vue?vue&type=script&lang=js&"
import style0 from "./expenseAccount.vue?vue&type=style&index=0&id=5936055f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5936055f",
  null
  
)

export default component.exports